import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainMenu from "./MainMenu";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import Swal from "sweetalert2";
import "./Newprofile.css";

function Newprofile() {

    const getISTDateTime = () => {
        const now = new Date();

        return new Intl.DateTimeFormat("en-CA", {
            timeZone: "Asia/Kolkata",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        })
            .format(now)
            .replace(",", "")
            .replace(/\//g, "-");
    };
    const [open, setOpen] = useState(true);

    // Auto collapse on mobile + auto expand on desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setOpen(false); // hide on mobile
            } else {
                setOpen(true); // show on desktop
            }
        };

        handleResize(); // run on load
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const initialForm = {
        id: "",
        billNo: "",
        regNo: "",
        name: "",
        bname: "",
        sex: "",
        caste: "",
        age: "",
        height: "",
        star: "",
        dhosham: "",
        qualification: [""],
        job: "",
        native: "",
        phone: "",
        fee: "",
        mode: "",
        remarks: ""
    };

    const initialForm1 = {
        // id: "",
        // no: "",
        // regNo: "",
        name: "",
        bname: "",
        phone: "",
        star: "",
        // job: "",
        // sex: "",
        // caste: "",
        age: "",
        // height: "",

        // dhosham: "",
        // qualification: [""],
        // native: "",
        // fee: "",
        // mode: "",
        // remarks: "",
        // date: ""
    };

    const [formData, setFormData] = useState(initialForm);
    const [records, setRecords] = useState([]);
    const [editId, setEditId] = useState(null);




    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        // const res = await fetch("http://localhost/api/get.php");
        const res = await fetch("https://kol.cubixsystems.com/api/get.php");
        const data = await res.json();
        setRecords(data);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCancel = () => {
        setFormData(initialForm);
        setEditId(null);

        // fetch("http://localhost/api/getRegNo.php")
        fetch("https://kol.cubixsystems.com/api/getRegNo.php")
            .then((res) => res.json())
            .then((data) => {
                setFormData((prev) => ({
                    ...prev,
                    regNo: data.regNo
                }));
            })
            .catch(err => console.error(err));

        fetchRecords();
    }

    // Qualification handlers
    const handleQualificationChange = (index, value) => {
        const updated = [...formData.qualification];
        updated[index] = value;
        setFormData({ ...formData, qualification: updated });
    };

    const addQualification = () => {
        setFormData({
            ...formData,
            qualification: [...formData.qualification, ""],
        });
    };

    const removeQualification = (index) => {
        const updated = formData.qualification.filter((_, i) => i !== index);
        setFormData({ ...formData, qualification: updated });
    };

    const navigate = useNavigate();

    const validateForm = () => {
        // if (!formData.regNo) return "Reg No is mandatory";
        if (!formData.name) return "Name is mandatory";
        // if (!formData.bname) return "Bhoomi Name is mandatory";
        // if (!formData.phone) return "Phone number is mandatory";
        // if (!formData.age) return "Age is mandatory";
        // if (!formData.height) return "Height is mandatory";
        if (!formData.sex) return "Gender is mandatory";
        // if (!formData.caste) return "Caste is mandatory";
        // if (!formData.star) return "Star is mandatory";
        // if (!formData.dhosham) return "Dhosham is mandatory";
        // if (!formData.job) return "Job is mandatory";
        // if (!formData.native) return "Native place is mandatory";

        // Qualification check
        // const hasEmptyQualification = formData.qualification.some(q => !q.trim());
        // if (hasEmptyQualification) return "Qualification is mandatory";

        // if (!formData.mode) return "Payment mode is mandatory";
        if (formData.phone.length !== 10) {
            return "Phone Number must be 10 digits";

        }

        return null; // ✅ no errors
    };

    const [file, setFile] = useState(null);

    const [previewFile, setPreviewFile] = useState(null);
    const openPreview = (file) => {
        setPreviewFile(file);
    };

    const [progress, setProgress] = useState(0);
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        const error = validateForm();

        if (error) {
            Swal.fire({
                icon: "warning",
                title: "Patient Registration",
                text: error
            });
            return;
        }

        // ✅ STEP 1: Get IST time
        const istDateTime = getISTDateTime();

        // ✅ STEP 2: Merge into formData
        const updatedFormData = {
            ...formData,
            created_at: istDateTime
        };

        const formDataToSend = new FormData();

        Object.keys(updatedFormData).forEach((key) => {
            formDataToSend.append(key, updatedFormData[key]);
        });

        if (file) {
            formDataToSend.append("file", file);
        }

        const url = editId
            ? "https://kol.cubixsystems.com/api/update.php"
            : "https://kol.cubixsystems.com/api/save.php";

        setLoading(true);
        setProgress(0);

        const xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percent = Math.round((event.loaded / event.total) * 100);
                setProgress(percent);
            }
        };

        xhr.onload = async () => {
            setLoading(false);

            try {
                const data = JSON.parse(xhr.responseText);

                if (data.status === "exists") {
                    Swal.fire({
                        icon: "warning",
                        title: "Duplicate Entry",
                        text: "Phone number already registered!"
                    });
                    return;
                }

                if (data.status === "success" || data.status === "updated") {
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: editId ? "Updated successfully" : "Registered successfully"
                    });

                    setFormData(initialForm);
                    setFile(null);
                    setEditId(null);

                    await fetchRecords();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: data.msg || "Something went wrong"
                    });
                }

            } catch (err) {
                console.error("Invalid JSON:", xhr.responseText);
            }
        };

        xhr.onerror = () => {
            setLoading(false);
            Swal.fire({
                icon: "error",
                title: "Connection Error",
                text: "Failed to connect to server"
            });
        };

        xhr.send(formDataToSend);
    };

    useEffect(() => {
        fetch("https://kol.cubixsystems.com/api/getRegNo.php")
            .then((res) => res.json())
            .then((data) => {
                console.log("BillNo API:", data); // 🔍 debug

                setFormData((prev) => ({
                    ...prev,
                    billNo: data.billNo
                }));
            })
            .catch((err) => console.error(err));
    }, []);

    const handleEdit = (rec) => {
        setFormData({
            ...rec,
            qualification: rec.qualification
                ? rec.qualification.split(",")
                : [""],
        });
        setEditId(rec.id);
    };

    const handleDelete = async (id) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This record will be permanently deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!"
        });

        if (result.isConfirmed) {
            try {
                const res = await fetch(`https://kol.cubixsystems.com/api/delete.php?id=${id}`);
                const data = await res.json();

                if (data.status === "deleted") {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: "Record deleted successfully",
                        timer: 1500,
                        showConfirmButton: false
                    });

                    // Refresh data
                    fetchRecords();

                    //Refresh billNo;
                    fetch("https://kol.cubixsystems.com/api/getRegNo.php")
                        .then((res) => res.json())
                        .then((data) => {
                            setFormData((prev) => ({
                                ...prev,
                                billNo: data.billNo
                            }));
                        });

                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: data.msg || "Delete failed"
                    });
                }

            } catch (err) {
                // Swal.fire({
                //     icon: "error",
                //     title: "Error",
                //     text: "Something went wrong"
                // });
            }
        }
        // ✅ Refresh page
        window.location.reload();
    };

    const [search, setSearch] = useState("");
    const filteredRecords = records.filter((rec) => {
        const searchText = search.toLowerCase();

        return (
            rec.name?.toLowerCase().includes(searchText) ||
            rec.phone?.toLowerCase().includes(searchText)
        );
    });

    const handlePrint = (rec) => {
        // store selected row data
        localStorage.setItem("printData", JSON.stringify(rec));

        // open print page in new tab
        window.open("/print", "_blank");
    };


    const [previewImage, setPreviewImage] = useState(null);

    return (
        <div className="container-fluid p-0">
            <div
                className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
                style={{
                    zIndex: 999,
                    cursor: "pointer",
                    position: "fixed",
                    left: open ? "350px" : "60px",
                    top: "0",
                    transition: "left 0.3s ease"
                }}
                onClick={() => setOpen(!open)}
            >
                <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
                    ☰
                </span>
            </div>

            <div className="d-flex" style={{ height: "100vh" }}>

                {/* LEFT SIDEBAR */}
                <div
                    className="border-end leftcolor"
                    style={{
                        width: open ? "350px" : "0",
                        overflow: "hidden",
                        transition: "0.3s ease",

                    }}
                >
                    {open && (
                        <div className="p-3">
                            <AdminLeft />
                        </div>
                    )}
                </div>

                {/* RIGHT CONTENT */}
                <div
                    className="p-4"
                    style={{
                        width: open ? "calc(100% - 350px)" : "100%",
                        transition: "0.3s ease",
                        paddiingLeft: '10px'
                    }}
                >
                    <div>
                        <TopBanner />
                    </div>
                    <div className="" style={{ height: '100vh', overflow: 'auto' }}>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="patient-form-card">

                                    <div className="card-heading">
                                        <div className="heading-icon">
                                            <i className="fa fa-user"></i>
                                        </div>

                                        <div>
                                            <h3>New Patient</h3>
                                            <p>Enter patient information</p>
                                        </div>
                                    </div>

                                    <div className="form-grid">

                                        <div className="form-field full">
                                            <label>Patient Name</label>

                                            <div className="input-wrapper">
                                                <i className="fa fa-user"></i>

                                                <input
                                                    name="name"
                                                    type="text"
                                                    placeholder="Enter patient name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>


                                        <div className="form-field">
                                            <label>Contact Number</label>

                                            <div className="input-wrapper">
                                                <i className="fa fa-phone"></i>

                                                <input
                                                    name="phone"
                                                    type="text"
                                                    placeholder="Contact number"
                                                    value={formData.phone}
                                                    maxLength={10}
                                                    onChange={(e) => {
                                                        const value =
                                                            e.target.value.replace(/\D/g, "");

                                                        if (value.length <= 10) {
                                                            setFormData({
                                                                ...formData,
                                                                phone: value
                                                            });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div className="form-field">
                                            <label>Age</label>

                                            <div className="input-wrapper">
                                                <i className="fa fa-calendar"></i>

                                                <input
                                                    name="age"
                                                    type="text"
                                                    placeholder="Age"
                                                    value={formData.age}
                                                    maxLength={2}
                                                    onChange={(e) => {
                                                        const value =
                                                            e.target.value.replace(/\D/g, "");

                                                        if (value.length <= 2) {
                                                            setFormData({
                                                                ...formData,
                                                                age: value
                                                            });
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>


                                        <div className="form-field full">
                                            <label>Gender</label>

                                            <div className="gender-options">

                                                {["Male", "Female"].map((s) => (
                                                    <label
                                                        key={s}
                                                        className={`gender-option ${formData.sex === s
                                                            ? "selected"
                                                            : ""
                                                            }`}
                                                    >
                                                        <input
                                                            type="radio"
                                                            name="sex"
                                                            value={s}
                                                            checked={formData.sex === s}
                                                            onChange={handleChange}
                                                        />

                                                        <i
                                                            className={
                                                                s === "Male"
                                                                    ? "fa fa-male"
                                                                    : "fa fa-female"
                                                            }
                                                        ></i>

                                                        {s}
                                                    </label>
                                                ))}

                                            </div>
                                        </div>


                                        <div className="form-field full">
                                            <label>Address</label>

                                            <div className="input-wrapper textarea-wrapper">
                                                <i className="fa fa-map-marker"></i>

                                                <textarea
                                                    name="remarks"
                                                    placeholder="Enter patient address"
                                                    value={formData.remarks}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>

                                    </div>


                                    {loading && (
                                        <div className="saving-container">

                                            <div className="progress-track">
                                                <div
                                                    className="progress-bar"
                                                    style={{
                                                        width: `${progress}%`
                                                    }}
                                                />
                                            </div>

                                            <span>
                                                Saving {progress}%
                                            </span>

                                        </div>
                                    )}


                                    <div className="form-actions">

                                        <button
                                            className="btn-register"
                                            onClick={handleSave}
                                            disabled={loading}
                                        >
                                            <i className="fa fa-check"></i>

                                            {loading
                                                ? "Processing..."
                                                : editId
                                                    ? "Update Patient"
                                                    : "Register Patient"}
                                        </button>

                                        <button
                                            className="btn-cancel"
                                            onClick={handleCancel}
                                        >
                                            Cancel
                                        </button>

                                    </div>

                                </div>
                            </div>

                            <div class="col-md-8" style={{ height: '80vh', overflow: 'auto', padding: '25px' }}>
                                <div className="patients-card">

                                    <div className="patients-header">

                                        <div>
                                            <h3>
                                                <i className="fa fa-users"></i>
                                                Patient List
                                            </h3>

                                            <p>
                                                Manage registered patients
                                            </p>
                                        </div>

                                        <span className="patient-count">
                                            {filteredRecords.length}
                                        </span>

                                    </div>


                                    <div className="patient-search">

                                        <i className="fa fa-search"></i>

                                        <input
                                            type="text"
                                            placeholder="Search by name, phone or MR ID..."
                                            value={search}
                                            onChange={(e) =>
                                                setSearch(e.target.value)
                                            }
                                        />

                                    </div>


                                    {/* DESKTOP TABLE */}

                                    <div className="desktop-patient-table">

                                        <table>

                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>MR ID</th>
                                                    <th>Patient</th>
                                                    <th>Phone</th>
                                                    <th>Age</th>
                                                    <th>Last Visited</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {filteredRecords.map((rec, index) => (

                                                    <tr key={rec.id}>

                                                        <td>{index + 1}</td>

                                                        <td>
                                                            <span className="mr-badge">
                                                                MR001
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <div className="patient-name">
                                                                <div className="patient-avatar">
                                                                    {rec.name
                                                                        ? rec.name.charAt(0).toUpperCase()
                                                                        : "P"}
                                                                </div>

                                                                <strong>
                                                                    {rec.name}
                                                                </strong>
                                                            </div>
                                                        </td>

                                                        <td>
                                                            <i className="fa fa-phone"></i>
                                                            {" "}
                                                            {rec.phone}
                                                        </td>

                                                        <td>{rec.age}</td>

                                                        <td>
                                                            {rec.date
                                                                ? new Intl.DateTimeFormat(
                                                                    "en-IN",
                                                                    {
                                                                        timeZone: "Asia/Kolkata",
                                                                        day: "2-digit",
                                                                        month: "short",
                                                                        year: "numeric",
                                                                        hour: "2-digit",
                                                                        minute: "2-digit",
                                                                        hour12: true
                                                                    }
                                                                ).format(
                                                                    new Date(
                                                                        rec.date.replace(
                                                                            " ",
                                                                            "T"
                                                                        )
                                                                    )
                                                                )
                                                                : "-"}
                                                        </td>

                                                        <td>

                                                            <div className="action-buttons">

                                                                <button
                                                                    className="action-edit"
                                                                    onClick={() =>
                                                                        handleEdit(rec)
                                                                    }
                                                                    title="Edit"
                                                                >
                                                                    <i className="fa fa-edit"></i>
                                                                </button>

                                                                <button
                                                                    className="action-delete"
                                                                    onClick={() =>
                                                                        handleDelete(rec.id)
                                                                    }
                                                                    title="Delete"
                                                                >
                                                                    <i className="fa fa-trash"></i>
                                                                </button>

                                                            </div>

                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>


                                    {/* MOBILE CARDS */}

                                    <div className="mobile-patient-list">

                                        {filteredRecords.map((rec, index) => (

                                            <div
                                                className="mobile-patient-card"
                                                key={rec.id}
                                            >

                                                <div className="mobile-patient-top">

                                                    <div className="patient-avatar">
                                                        {rec.name
                                                            ? rec.name.charAt(0).toUpperCase()
                                                            : "P"}
                                                    </div>

                                                    <div>

                                                        <h4>
                                                            {rec.name}
                                                        </h4>

                                                        <span>
                                                            MR001
                                                        </span>

                                                    </div>

                                                </div>


                                                <div className="patient-details">

                                                    <div>
                                                        <small>Phone</small>
                                                        <strong>
                                                            {rec.phone}
                                                        </strong>
                                                    </div>

                                                    <div>
                                                        <small>Age</small>
                                                        <strong>
                                                            {rec.age}
                                                        </strong>
                                                    </div>

                                                </div>


                                                <div className="last-visited">

                                                    <i className="fa fa-clock-o"></i>

                                                    {rec.date
                                                        ? new Intl.DateTimeFormat(
                                                            "en-IN",
                                                            {
                                                                timeZone: "Asia/Kolkata",
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric",
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                                hour12: true
                                                            }
                                                        ).format(
                                                            new Date(
                                                                rec.date.replace(
                                                                    " ",
                                                                    "T"
                                                                )
                                                            )
                                                        )
                                                        : "No visit"}

                                                </div>


                                                <div className="mobile-actions">

                                                    <button
                                                        onClick={() =>
                                                            handleEdit(rec)
                                                        }
                                                    >
                                                        <i className="fa fa-edit"></i>
                                                        Edit
                                                    </button>

                                                    <button
                                                        onClick={() =>
                                                            handleDelete(rec.id)
                                                        }
                                                    >
                                                        <i className="fa fa-trash"></i>
                                                        Delete
                                                    </button>

                                                </div>

                                            </div>

                                        ))}

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="container">




            </div>
            {previewImage && (
                <div
                    onClick={() => setPreviewImage(null)}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 9999
                    }}
                >
                    <img
                        src={previewImage}
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            borderRadius: "8px"
                        }}
                    />
                </div>
            )}
        </div>

    );
}


export default Newprofile;

